// src/store/slices/categoriesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constants/apiUrl";

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (filters, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state


      console.log(state.auth.userArray.access_token, "state.auth.userArray.access_token");

      const response = await axios.get(
        `${apiUrl}/admin/categories`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addCategory = createAsyncThunk(
  "trainers/addCategory",
  async (categoryData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/categories`, categoryData, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
async ({ id, data }, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/categories/${id}`, data, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    list: [],
status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(addCategory.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(addCategory.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(updateCategory.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(updateCategory.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })

  },
});

export default categoriesSlice.reducer;
